/* eslint-disable @typescript-eslint/no-explicit-any */
import { IDocs } from '_core/types';
import { GenericMachine } from '../../Generic/Machines/GenericMachine';
import { partnerTokenApi as API } from '../Apis';

export const PartnerTokenDocs: IDocs = {
  title: 'PartnerToken',
  description: '',
  version: '0.0.1',
  apis: [
    {
      name: API.definitions.API_DOMAIN,
      path: API.definitions.ENDPOINT_API_PATH,
      linkPostman: API.definitions.URL_POSTMAN,
      order: 1,
    },
  ],
  codeToExecute: 'Services.UtilsServices.partnerToken',
};

const prepareCall = (stateRequestParameters: any) =>
  API.call.post({
    type: stateRequestParameters?.partner,
  });

export const PartnerTokenMachine = GenericMachine(prepareCall, {
  docs: PartnerTokenDocs,
  definitions: API.definitions,
});
